import React from "react"
import { ChevronRight } from "lucide-react"
import { cn } from "../../lib/utils"
import { useSidebar } from "./sidebar"

const SidebarExpandableTrigger = React.forwardRef(({ className, ...props }, ref) => {
  const { toggleSidebar, state, isMobile, openMobile } = useSidebar()
  const isCollapsed = state === "collapsed"

  // Show trigger on both mobile and desktop with appropriate styling

  return (
    <button
      ref={ref}
      onClick={toggleSidebar}
      className={cn(
        "flex h-8 w-8 items-center justify-center rounded-md bg-gray-100 shadow-sm border border-gray-200 transition-all duration-300 ease-in-out hover:shadow-md hover:bg-gray-200",
        "focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50",
        className
      )}
      title={isMobile ? (openMobile ? "Close Sidebar" : "Open Sidebar") : (isCollapsed ? "Expand Sidebar" : "Collapse Sidebar")}
      aria-label={isMobile ? (openMobile ? "Close Sidebar" : "Open Sidebar") : (isCollapsed ? "Expand Sidebar" : "Collapse Sidebar")}
      {...props}
    >
      <ChevronRight 
        className={cn(
          "h-5 w-5 text-gray-700 transition-all duration-300 ease-in-out",
          isMobile 
            ? openMobile ? "rotate-180" : "rotate-0"
            : isCollapsed ? "rotate-0" : "rotate-180",
          "hover:text-gray-900"
        )}
      />
    </button>
  )
})

SidebarExpandableTrigger.displayName = "SidebarExpandableTrigger"

export { SidebarExpandableTrigger }